import { css } from "lit";

export const purchasesPageStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: var(--sds-size-space-800);
  }

  .success-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-600);
    text-align: center;
    max-width: 500px;
  }

  .success-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: var(--sds-color-background-positive-default);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
  }

  .success-title {
    color: var(--sds-color-text-default-default);
    font: var(--sds-typography-weight-medium) var(--sds-typography-heading-size) / 150%
      var(--sds-typography-family-title);
    margin: 0;
  }

  .success-message {
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-large) / 140%
      var(--sds-typography-family-body);
    margin: 0;
  }

  .spinner {
    width: 24px;
    height: 24px;
    border: 3px solid var(--sds-color-border-default-default);
    border-top-color: var(--sds-color-border-brand-default);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-600);
    text-align: center;
    max-width: 500px;
  }

  .error-message {
    color: var(--sds-color-text-danger-default);
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-large) / 140%
      var(--sds-typography-family-body);
  }
`;
